import Adjust from '@adjustcom/adjust-web-sdk';
import { environment } from '@env/environment';

export const ADJUST_EVENT_TOKEN = {
  ADDON_SERVICE_CONFIRM: {
    label: 'Flight_addon_service_confirm',
    sandbox: '569ieb',
    live: 'ts9cyy',
  },
  SERVICE_DONE: {
    label: 'Flight_service_done',
    sandbox: '569ieb',
    live: 'ts9cyy',
  },
  CHECKOUT: {
    label: 'Flight_checkout',
    sandbox: '39ua17',
    live: 'd9wso5',
  },
  DETAIL_BOOKED: {
    label: 'Flight_detail_booked',
    sandbox: 'ekzm1x',
    live: '8xwve4',
  },
  FAVOURITE_MARK: {
    label: 'Flight_favourite_mark',
    sandbox: 'wddsuk',
    live: 'djn375',
  },
  HOMEPAGE_VIEW: {
    label: 'Flight_homepage_view',
    sandbox: 'q0c1tb',
    live: 'eyhy2w',
  },
  INFO_CONFIRM: {
    label: 'Flight_info_confirm',
    sandbox: '7yhc92',
    live: 'v18ecs',
  },
  ORDER_TRACKING: {
    label: 'Flight_order_tracking',
    sandbox: 'vehx3j',
    live: '3r9rdi',
  },
  ORDER_TRACKING_SUCCESSFUL: {
    label: 'Flight_order_tracking_successful',
    sandbox: '6ffg9e',
    live: 'swyq16',
  },
  PAYMENT_CANCEL: {
    label: 'Flight_payment_cancel',
    sandbox: '6szjo7',
    live: 'sy3cl7',
  },
  PAYMENT_FAIL: {
    label: 'Flight_payment_fail',
    sandbox: 'a44frn',
    live: 'hw94ej',
  },
  PAYMENT_PROCESS: {
    label: 'Flight_payment_process',
    sandbox: 'k6f3wo',
    live: '4m6mi6',
  },
  PAYMENT_SUCCESS: {
    label: 'Flight_payment_success',
    sandbox: 'rib2o2',
    live: 's1x8w1',
  },
  PAYMENT_WAITING: {
    label: 'Flight_payment_waiting',
    sandbox: 'rbklid',
    live: 'uu25es',
  },
  PRICE_UPDATE: {
    label: 'Flight_PriceUpdate',
    sandbox: 'oht94k',
    live: 'n58o2g',
  },
  PROMOTION_CONFIRM: {
    label: 'Flight_promotion_confirm',
    sandbox: 'w2nnag',
    live: 'fkgvlv',
  },
  SEARCH: {
    label: 'Flight_search',
    sandbox: '4wvgti',
    live: '910nfj',
  },
  SEARCH_SELECT: {
    label: 'Flight_search_select',
    sandbox: '9tqqke',
    live: 'tnqzsf',
  },
  TRENDING_SELECT: {
    label: 'Flight_trending_select',
    sandbox: 'kpz11m',
    live: 'to2qoa',
  },
};

export const AdjustInstance = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  instance: undefined as any,
  init() {
    if (!this.instance) {
      this.instance = Adjust;
      Adjust.initSdk({
        appToken: environment.APP_ADJUST_TOKEN || '',
        environment: environment.production ? 'production' : 'sandbox',
        logLevel: environment.production ? 'info' : 'verbose',
      });
    }
  },

  trackingEvent(eventName: string) {
    const eventData = Object.values(ADJUST_EVENT_TOKEN).find(
      (i) => i.label === eventName
    );
    if (!eventData?.label || !this.instance) return;

    if (eventData?.label && this.instance?.trackEvent) {
      Adjust.trackEvent({
        eventToken: environment.production ? eventData.live : eventData.sandbox,
      });
    }
  },
  stop() {
    if (this.instance) Adjust.stop();
  },
};
